import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import { Spin, Row, Select, Button, DatePicker, Input } from 'antd';
import './index.scss';
import CashFlow from './cashFlow';
import OperationalCapability from './operationalCapability';
import Profitability from './profitability';
import BusinessForecast from './businessForecast';
import CostAnalysis from "./CostAnalysis"
import { runInAction } from 'mobx';
import moment from 'moment';

const { Option } = Select;

@inject('store')
@observer
class App extends Component {
    state = {
        dateData: [],
    }

    componentDidMount() {
        let date = Number(this.props.store.monthlyAnalysis.date || "0");
        let dateData = [];
        let len = date - 2018 + 3;
        for (let i = 0; i < len; i++) {
            dateData.push((2018 + i).toString())
        }
        this.setState({ dateData });
        this.props.store.monthlyAnalysis.getData(this.props.store.monthlyAnalysis.date);
    }

    render() {
        const { loading, date, getData, onSave, saving, notes } = this.props.store.monthlyAnalysis;
        return (
            <Spin spinning={loading}>
                <div className="table7_1_1 monthlyAnalysis">
                    <Row className="title" id="table11">
                        <Row>财务月度分析报告</Row>
                        <Row className="table-month">
                            <Select
                                placeholder="请选择年份"
                                style={{ width: 120 }}
                                value={date}
                                onChange={str => {
                                    runInAction(() => {
                                        this.props.store.monthlyAnalysis.date = str;
                                    });
                                    getData(str);
                                }}
                            >
                                {this.state.dateData.map((x, i) => {
                                    return (
                                        <Option key={x}>{x}年</Option>
                                    )
                                })}
                            </Select>
                        </Row>
                        <CashFlow />
                        <OperationalCapability />
                        <Profitability />
                        <CostAnalysis />
                        <BusinessForecast />
                        <div className="fillInThe">
                            <span>填写人</span>
                            {!loading && <Input
                                defaultValue={notes.name}
                                onBlur={e => {
                                    runInAction(() => {
                                        this.props.store.monthlyAnalysis.notes.name = e.target.value || "";
                                    })
                                }}
                                placeholder={`请输入填写人姓名`}
                            />}
                            <span>填写日期</span>
                            {!loading && <DatePicker
                                defaultValue={notes.date && moment(notes.date)}
                                onChange={(__, str) => {
                                    runInAction(() => {
                                        this.props.store.monthlyAnalysis.notes.date = str || "";
                                    })
                                }} />}
                        </div>
                        <Button
                            className="footer-btn"
                            type="primary"
                            onClick={onSave}
                            loading={saving}
                        >
                            保存
                        </Button>
                    </Row>
                </div>
            </Spin>

        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/table/monthlyAnalysis/index.js